// import axios from 'axios';

// export const BASE_URL = 'https://api.lanuderia.com:5000/v1'; ///       'https://api.lanuderia.com:5000/v1'      'http://localhost:5000/v1'


// export const publicRequest = axios.create({
//     baseURL: BASE_URL,
//     headers: { 'Content-Type': 'application/json'},
//     withCredentials: true,
// });


// const privateRequest = axios.create({
//     baseURL: BASE_URL,
//     headers: { 'Content-Type': 'application/json'},
//     withCredentials: true,
//     timeout: 1800000,
// });




// const refresh = async () => {
    
//     const res = await publicRequest.get('/auth/refresh', {
//         withCredentials: true
//     });
    
//     return res.data.accessToken;

// }


// // privateRequest.interceptors.request.use(
// //     config => {
// //         if (!config.headers['Authorization']) {
// //             config.headers['Authorization'] = `Bearer ${accessToken}`;
// //         }
// //         return config;
// //     }, (error) => Promise.reject(error)
// // );

// privateRequest.interceptors.response.use(
//     response => response,
//     async (error) => {
//         const prevReq = error?.config;
//         if (error?.response?.status === 403 && !prevReq?.sent) {
//             prevReq.sent = true;
//             let newAccessToken = await refresh()
            
//             return privateRequest({
//                 ...prevReq,
//                 headers: {...prevReq.headers, Authorization: `Bearer ${newAccessToken}`},
//                 sent: true
//             });   
//         } 
//         return Promise.reject(error);
//     }
// );


// //return () => {
// //    privateRequest.interceptors.request.eject(reqIntercept);
// //    privateRequest.interceptors.response.eject(resIntercept);
// //}

// export default privateRequest;


import axios from "axios";

export const BASE_URL = "https://api.lanuderia.com:5000/v1";

export const publicRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

const privateRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  timeout: 1800000,
});

// ✅ token en memoria (no localStorage)
let accessTokenCache = null;
// ✅ evita refresh duplicados en paralelo
let refreshPromise = null;

const refresh = async () => {
  if (!refreshPromise) {
    refreshPromise = publicRequest
      .get("/auth/refresh", { withCredentials: true })
      .then((res) => {
        const token = res.data.accessToken;
        accessTokenCache = token;
        privateRequest.defaults.headers.common.Authorization = `Bearer ${token}`;
        return token;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

// ✅ request interceptor: asegura Authorization SIEMPRE antes de enviar
privateRequest.interceptors.request.use(async (config) => {
  if (!accessTokenCache) {
    await refresh();
  }
  config.headers = config.headers || {};
  if (!config.headers.Authorization && accessTokenCache) {
    config.headers.Authorization = `Bearer ${accessTokenCache}`;
  }
  return config;
});

// ✅ response interceptor: por si el token expiró igual, refresca y reintenta
privateRequest.interceptors.response.use(
  (res) => res,
  async (error) => {
    const prevReq = error?.config;
    if (error?.response?.status === 403 && !prevReq?.sent) {
      prevReq.sent = true;
      const newToken = await refresh();
      prevReq.headers = prevReq.headers || {};
      prevReq.headers.Authorization = `Bearer ${newToken}`;
      return privateRequest(prevReq);
    }
    return Promise.reject(error);
  }
);

export default privateRequest;